import { Injectable, inject } from '@angular/core';
import { RequestService } from '@seu-services';
import { SEU_API_ENDPOINTS, SeuConfigApi } from '@seu-types';
import { catchError, firstValueFrom, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly requestService = inject(RequestService);

  public async fetchConfig(): Promise<SeuConfigApi | null> {
    const endpoint = SEU_API_ENDPOINTS.setup;

    const config = await firstValueFrom(
      this.requestService.get<SeuConfigApi>(endpoint as SEU_API_ENDPOINTS).pipe(
        catchError(() => {
          return of(null);
        })
      )
    );

    return config;
  }
}
